// Copyright (c) 2020 Deere & Company

import RgaDomainValues, {getDefaultState as getDefaultRgaDomainValues} from './rga-domain-values';
import t from 'tcomb';

const RGADomainValuesState = t.struct({
    rgaDomainValues: RgaDomainValues
}, 'RGADomainValuesState');

export const getDefaultState = () =>
    new RGADomainValuesState({
        rgaDomainValues: getDefaultRgaDomainValues()
    });

export default RGADomainValuesState;



// WEBPACK FOOTER //
// ./src/rga/shared/rga-domain-values/state/index.js